import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_INTEGRATION_CONFIG](state, payload) {
    state.integration = payload;
  },
  [MutationsType.SET_INTEGRATION_ZOOM_WEBINARS](state, payload) {
    state.integrationZoomWebinars = payload;
  },
  [MutationsType.SET_INTEGRATION_SENDGRID](state, payload) {
    state.integrationSendGrid = payload;
  },
  [MutationsType.UPDATE_INTEGRATION_SENDGRID](state, payload) {
    state.integrationSendGrid = { ...state.integrationSendGrid, ...payload };
  },
  [MutationsType.SET_INTEGRATION_WHATSAPP](state, payload) {
    state.integrationWhatsApp = payload;
  },
  [MutationsType.UNSUBSCRIBE_GET_INTEGRATION_WHATSAPP](state, payload) {
    state.unsubscribeIntegrationWhatsApp = payload;
  },
  [MutationsType.SET_INTEGRATION_FB_CATALOG](state, payload) {
    state.integrationFbCatalog = payload;
  },
};
